import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function GCPIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M15.1126 7.55619H15.1876L15.1501 7.51869L17.7751 4.89369V4.83744C15.5626 2.88744 12.5063 2.21244 9.6751 3.05619C6.84385 3.89994 4.66885 6.14994 3.88135 8.99994C3.91885 8.98119 3.9751 8.96244 4.03135 8.96244C5.00635 8.32494 6.16885 7.94994 7.3876 7.94994C7.8001 7.94994 8.19385 7.98744 8.5876 8.06244C8.60635 8.04369 8.6251 8.04369 8.64385 8.04369C10.3313 6.18744 13.1813 5.96244 15.1313 7.55619H15.1126Z"
        fill="#EA4535"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M20.2687 8.9626C19.8374 7.36885 18.9374 5.9251 17.6812 4.81885L14.9999 7.48135C16.1249 8.4001 16.7812 9.7876 16.7437 11.2313V11.7001C19.9124 11.7001 19.9124 16.4251 16.7437 16.4251H11.9812V20.1751H11.9624L11.9812 20.2126H16.7437C19.4812 20.2313 21.8999 18.4688 22.7062 15.8813C23.5124 13.2938 22.5187 10.4813 20.2687 8.9626Z"
        fill="#557EBF"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M7.3127 20.2311H12.2439V16.4436H7.3127C6.95645 16.4436 6.61895 16.3686 6.3002 16.2373L3.4502 18.9748V19.0123C4.5752 19.8186 5.9252 20.2498 7.33145 20.2498L7.3127 20.2311Z"
        fill="#36A852"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M7.53772 7.85645C4.74397 7.8752 2.26897 9.60019 1.36897 12.1314C0.46897 14.6814 1.36897 17.4752 3.58147 19.1252L6.50647 16.3314C4.89397 15.6377 4.51897 13.6127 5.75647 12.4314C6.99397 11.2314 9.09397 11.6064 9.82522 13.1439L12.7502 10.3502C11.5127 8.79395 9.58147 7.87519 7.53772 7.89394V7.85645Z"
        fill="#F9BC15"
      />
    </svg>
  );
};
